/**
 * DemocratCharts — auth store.
 *
 * Access token lives in memory only. Refresh token is in an HttpOnly cookie
 * that JS cannot touch (the api.ts interceptor uses withCredentials).
 * On page reload, the app calls /api/auth/refresh once and either gets a
 * fresh access token or kicks to /login.
 */

import { create } from "zustand";

interface User {
  id: string;
  email: string;
  full_name: string;
  role: "admin" | "trader";
}

interface AuthState {
  accessToken: string | null;
  user: User | null;
  loading: boolean;
  setAccessToken: (token: string) => void;
  setUser: (user: User) => void;
  clear: () => void;
  setLoading: (loading: boolean) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  accessToken: null,
  user: null,
  loading: true, // start as loading; the initial /me hydration sets it false

  setAccessToken: (token) => set({ accessToken: token }),
  setUser: (user) => set({ user }),
  clear: () => set({ accessToken: null, user: null, loading: false }),
  setLoading: (loading) => set({ loading }),
}));
